import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { IntroducingBrokerSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import { TradingAccountStatusIcon } from './SearchStatusIcon'

export const IntroducingBrokerColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps) => {
      const data = props.dataItem as IntroducingBrokerSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: data.id,
                slug: 'details',
              }),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Client',
    cell: (props: GridCellProps) => {
      const data = props.dataItem as IntroducingBrokerSearchResultDto
      if (!data.data.clientName) {
        return <td />
      }
      if (!data.data.clientId) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsClients.detailsUrl as string, {
                id: data.data.clientId,
                slug: 'details',
              }),
            }}
          >
            {data.data.clientName}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Status',
    cell: (props: GridCellProps) => {
      const data = props.dataItem as IntroducingBrokerSearchResultDto
      if (!data.data.status) {
        return <td />
      }
      return (
        <td>
          <span>
            {data.data.status.name} <TradingAccountStatusIcon statusId={data.data.status.id} />
          </span>
        </td>
      )
    },
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps) => {
      const data = props.dataItem as IntroducingBrokerSearchResultDto
      if (!data.data?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td className='table-columns__content'>
          <CompanyTag id={data.data.tickmillCompany.id}>
            {data.data.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    width: 80,
    minResizableWidth: 80,
  },
]
